import type { Blockquote, PhrasingContent, Root } from 'mdast';
import type { Plugin } from 'unified';
import { visit } from 'unist-util-visit';

// GitHub-style alert syntax (`> [!NOTE]`, `> [!WARNING]`, ...) — remark-gfm bunu
// desteklemiyor, bu yüzden işlenmeden ham metin olarak kalıyordu.
const ALERT_LABELS: Record<string, string> = {
  NOTE: 'Not',
  TIP: 'İpucu',
  IMPORTANT: 'Önemli',
  WARNING: 'Uyarı',
  CAUTION: 'Dikkat',
};

const MARKER_RE = /^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]\s*/;

const remarkAlerts: Plugin<[], Root> = () => (tree) => {
  visit(tree, 'blockquote', (node: Blockquote) => {
    const firstParagraph = node.children[0];
    if (!firstParagraph || firstParagraph.type !== 'paragraph') return;

    const first = firstParagraph.children[0];
    if (!first || first.type !== 'text') return;

    const match = MARKER_RE.exec(first.value);
    if (!match) return;

    const type = match[1];
    first.value = first.value.slice(match[0].length);
    if (first.value === '') firstParagraph.children.shift();

    const title: PhrasingContent = {
      type: 'strong',
      children: [{ type: 'text', value: ALERT_LABELS[type] }],
      data: { hProperties: { className: ['md-alert-title'] } },
    };
    firstParagraph.children.unshift(title, { type: 'text', value: ': ' });

    node.data = {
      hName: 'div',
      hProperties: { className: ['md-alert', `md-alert-${type.toLowerCase()}`] },
    };
  });
};

export default remarkAlerts;
